
import ModuleHeader from "../components/ModuleHeader/ModuleHeader";
import ExpenseTabs from "../expenses/ExpenseTabs";
import usePrivateLink from "../config/usePrivateLink";

export default function ExpenseLayout({ children }) {
  return ;
  const hasAccess = usePrivateLink();

  const visibleTabs = ExpenseTabs.filter((tab) =>
    hasAccess(tab.path)
  );

  return (
    <>
      <ModuleHeader tabs={visibleTabs} />
      {children}
    </>
  );
}
